import React, { useEffect, useState } from "react";
import dropdown from "../assets/images/dropdown.png";
import statusImg from "../assets/images/status_img.svg";
import Subscribed from "../assets/images/Subscribed.svg";
import UnSubscribed from "../assets/images/Unsubscribed.svg";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import { PieChart, Pie } from "recharts";
import { LineChart, Tooltip, ResponsiveContainer, Line } from "recharts";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { Bar } from "react-chartjs-2";
import Chart from "chart.js/auto";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Loader from "./Loader";
import { CategoryScale } from "chart.js";
import { SpinnerCircular } from "spinners-react";
Chart.register(CategoryScale);
Chart.defaults.elements.bar.borderRadius = 30;
Chart.defaults.datasets.bar.barThickness = 10;

export default function AdminDashBord() {
  const token = GetStorage.get("xAuthToken");
  const [dataset1, set1] = useState(["0"]);
  const [dataset2, set2] = useState(["0"]);
  const [labels, setLabels] = useState(["1"]);
  const [total, setTotal] = useState(0);
  const [swimmerDataByTeam, setSwimmerDataByTeam] = useState([]);
  const [monthAndYear, setMonthAndYear] = useState(new Date());
  const [teamGroupSelection, setTeamGroupSelection] = useState([]);
  const [teamSelection, setTeamSelection] = useState([]);
  const [swimmerSelection, setSwimmerSelection] = useState([]);
  const [isSwimmerDropDownDisabled, setIsSwimmerDropDownDisabled] =
    useState(true);
  const [isTeamGroupDropDownDisabled, setIsTeamGroupDropDownDisabled] =
    useState(true);
  const [teamGroupData, setTeamGroupData] = useState([]);
  const [teamData, setTeamData] = useState([]);
  const [videoFilmed, setVideoFilmed] = useState([]);
  const [totalVideoFilmed, setTotalVideoFilmed] = useState([]);
  const [videoViewedDetails, setVideoViewedDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const currentYearFirstDate = new Date(new Date().getFullYear(), 0, 1).toString();
  const today = new Date().toString();
  const [dateRange, setDateRange] = useState([currentYearFirstDate, today]);
  const [startDate, endDate] = dateRange;
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [groupSearchTerm, setGroupSearchTerm] = useState("");
  const [swimmerSearchTerm, setSwimmerSearchTerm] = useState("");
  const [isGroupDropdownOpen, setIsGroupDropdownOpen] = useState(false);
  const [isSwimmerDropdownOpen, setIsSwimmerDropdownOpen] = useState(false);
  // const [data, setData] = useState();

  // const pdata = [
  //   {
  //     name: "MongoDb",
  //     student: 11,
  //     fees: 120,
  //   },
  //   {
  //     name: "Javascript",
  //     student: 50,
  //     fees: 12,
  //   },
  //   {
  //     name: "PHP",
  //     student: 5,
  //     fees: 10,
  //   },
  //   {
  //     name: "Java",
  //     student: 100,
  //     fees: 5,
  //   },
  //   {
  //     name: "C#",
  //     student: 9,
  //     fees: 4,
  //   },
  //   {
  //     name: "C++",
  //     student: 10,
  //     fees: 8,
  //   },
  //   {
  //     name: "Cc+",
  //     student: 200,
  //     fees: 8,
  //   },
  //   {
  //     name: "C+",
  //     student: 12,
  //     fees: 8,
  //   },
  // ];
  const options = {
    scales: {
      xAxes: [
        {
          barThickness: 5,
        },
      ],
    },

    responsive: true,
    legend: {
      display: false,
    },

    type: "bar",
  };

  const [swimmer, setSwimmer] = useState([]);
  const [evo, setEvo] = useState([]);
  const [gender, setGender] = useState({});
  const [order, setOrder] = useState({});
  const [currentMonth, setcurrentMonth] = useState(1);
  const [subs, setSubs] = useState({});
  const [totalSub, setTolatSub] = useState();

  const handleChange = (e) => {
    http
      .get(`api/admin/dashboard?month=${e.target.value}&token=${token}`)
      .then((res) => {
        console.log("dash bord response ", res.data);
        const swimmer = res.data.swimmersByGender.swimmersByGender;
        const genderTotal = res.data.swimmersByGender;
        setGender(genderTotal);
        setSwimmer(swimmer);
        const evo = res.data.evoByStatus.evoByStatus;
        const orderTotal = res.data.evoByStatus;
        setOrder(orderTotal);
        setEvo(evo);
        set1(res.data.viewsObj.dataset1);
        set2(res.data.viewsObj.dataset2);
        setLabels(res.data.viewsObj.labels);
        setTotal(res.data.viewsObj.totelViews);
      })
      .catch((error) => {
        console.log("error in dashbord---->", error.message);
      });
  };

  const getDashboardDataWithAllFilter = (startDate = "", endDate = "") => {

    http
      .get(
        `api/admin/dashboard?month=${monthAndYear.getMonth() + 1
        }&year=${monthAndYear.getFullYear()}&teamId=${teamSelection}&teamGroupId=${teamGroupSelection}&swimmerId=${swimmerSelection}&startDate=${moment(dateRange[0]).format("YYYY-MM-DD")}&endDate=${moment(dateRange[1]).format("YYYY-MM-DD")}&token=${token}`
      )
      .then((res) => {
        setSubs(res.data.subs[0]);
        setTolatSub(res.data.totalSubs);
        const swimmer = res.data.swimmersByGender.swimmersByGender;
        const genderTotal = res.data.swimmersByGender;
        setGender(genderTotal);
        setSwimmer(swimmer);
        const evo = res.data.evoByStatus.evoByStatus;
        const orderTotal = res.data.evoByStatus;
        setOrder(orderTotal);
        setEvo(evo);
        set1(res.data.viewsObj.dataset1);
        set2(res.data.viewsObj.dataset2);
        setLabels(res.data.viewsObj.labels);
        setTotal(res.data.viewsObj.totelViews);
        setVideoFilmed(res.data.videoFilmedByUser);
        setTotalVideoFilmed(res.data.totalVideosFilmed);
        setVideoViewedDetails(res.data.viewsObj);
        setLoading(false);
      })
      .catch((error) => {
        console.log("error in dashbord---->", error.message);
      });
  }

  useEffect(() => {
    // GraphData();
    getTeamList();
  }, []);

  useEffect(() => {
    setLoading(true);

    http
      .get(
        `api/admin/dashboard?teamId=${teamSelection}&teamGroupId=${teamGroupSelection}&swimmerId=${swimmerSelection}&startDate=${moment(dateRange[0]).format("YYYY-MM-DD")}&endDate=${moment(dateRange[1]).format("YYYY-MM-DD")}&token=${token}`
      )
      .then((res) => {
        setSubs(res.data.subs[0]);
        setTolatSub(res.data.totalSubs);
        const swimmer = res.data.swimmersByGender.swimmersByGender;
        const genderTotal = res.data.swimmersByGender;
        setGender(genderTotal);
        setSwimmer(swimmer);
        const evo = res.data.evoByStatus.evoByStatus;
        const orderTotal = res.data.evoByStatus;
        setOrder(orderTotal);
        setEvo(evo);
        set1(res.data.viewsObj.dataset1);
        set2(res.data.viewsObj.dataset2);
        setLabels(res.data.viewsObj.labels);
        setTotal(res.data.viewsObj.totelViews);
        setVideoFilmed(res.data.videoFilmedByUser);
        setTotalVideoFilmed(res.data.totalVideosFilmed);
        setVideoViewedDetails(res.data.viewsObj);
        setLoading(false);
      })
      .catch((error) => {
        console.log("error in dashbord---->", error.message);
      });
    // getDashboardDataWithAllFilter()
  }, [teamSelection, teamGroupSelection, swimmerSelection, monthAndYear, dateRange]);

  const GraphData = async () => {
    const date = new Date();
    const month = date.getMonth() + 1;
    setcurrentMonth(month);
    http
      .get(`api/admin/dashboard?month=${month}&token=${token}`)
      .then((res) => {
        setSubs(res.data.subs[0]);
        setTolatSub(res.data.totalSubs);
        const swimmer = res.data.swimmersByGender.swimmersByGender;
        const genderTotal = res.data.swimmersByGender;
        setGender(genderTotal);
        setSwimmer(swimmer);
        const evo = res.data.evoByStatus.evoByStatus;
        const orderTotal = res.data.evoByStatus;
        setOrder(orderTotal);
        setEvo(evo);
        set1(res.data.viewsObj.dataset1);
        set2(res.data.viewsObj.dataset2);
        setLabels(res.data.viewsObj.labels);
        setTotal(res.data.viewsObj.totelViews);
      })
      .catch((error) => {
        console.log("error in dashbord---->", error.message);
      });
  };

  const getTeamList = () => {
    http
      .get(`api/admin/team/dropdown/list?token=${token}`)
      .then((res) => {
        setTeamData(res.data);
      })
      .catch((error) => {
        console.log("error in coach portal", error);
      });
  };

  const getTeamGroupList = (team_id) => {
    http
      .get(`api/teamgroup/byteam/${team_id}?token=${token}`)
      .then((res) => {
        setTeamGroupData(res.data);
      })
      .catch((error) => {
        console.log("error in coach portal", error);
      });
  };

  const getSwimmerListByTeam = (teamGroupId, teamId) => {
    if (teamGroupId != "teamID") {

      http
        .get(`api/team/swimmers/${teamSelection}/${teamGroupId}/?token=${token}`)
        .then((res) => {
          setSwimmerDataByTeam(res.data);
        })
        .catch((error) => {
          console.log("error in coach portal", error);
        });
    } else {
      http
        .get(`api/team/swimmers/${teamId}/?token=${token}`)
        .then((res) => {
          setSwimmerDataByTeam(res.data);
        })
        .catch((error) => {
          console.log("error in coach portal", error);
        });
    }
  };

  const handleMonthAndYear = (date) => {
    if (date) {
      setMonthAndYear(date);
    }
  };

  const handleTeamGroupDropDown = (event) => {
    setTeamGroupSelection(event.target.value);
    setSwimmerSelection([]);

    if (event.target.value != "0") {
      setIsSwimmerDropDownDisabled(false);
      getSwimmerListByTeam(event.target.value);
    } else {
      setIsSwimmerDropDownDisabled(false);
      getSwimmerListByTeam("teamID", teamSelection);
    }
  };

  const handleTeamDropDown = (event) => {
    setTeamSelection(event.target.value);
    setTeamGroupSelection([]);
    setSwimmerSelection([]);
    setIsSwimmerDropDownDisabled(true);

    if (event.target.value != "0") {
      setIsTeamGroupDropDownDisabled(false);
      setIsSwimmerDropDownDisabled(false);
      getTeamGroupList(event.target.value);
      getSwimmerListByTeam("teamID", event.target.value);
    } else {
      setIsTeamGroupDropDownDisabled(true);
    }
  };

  const handleSwimmerDropDown = (event) => {
    setSwimmerSelection(event.target.value);
    setIsSwimmerDropdownOpen(false);
  };

  const handleClearAll = () => {
    setTeamSelection([]);
    setTeamGroupSelection([]);
    setSwimmerSelection([]);
    setDateRange([null, null])
    setMonthAndYear(new Date()); // Reset the date picker
    setIsSwimmerDropDownDisabled(true);
    setIsTeamGroupDropDownDisabled(true);
  };

  const handleDatePicker = (dateSelection) => {
    setDateRange(dateSelection);
  }

  const filteredTeamData = teamData.filter((team) =>
    team.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredGroupData = teamGroupData.filter((group) =>
    group.name.toLowerCase().includes(groupSearchTerm.toLowerCase())
  );
  
  const filteredSwimmerData = swimmerDataByTeam.filter((swimmer) =>
    swimmer.fullname.toLowerCase().includes(swimmerSearchTerm.toLowerCase())
  );
  

  const handleTeamSelectionWithSearchFilter = (teamId) => {
    setTeamSelection(teamId);
    setIsDropdownOpen(false);

    setTeamGroupSelection([]);
    setSwimmerSelection([]);
    setIsSwimmerDropDownDisabled(true);

    if (teamId != "0") {
      setIsTeamGroupDropDownDisabled(false);
      setIsSwimmerDropDownDisabled(false);
      getTeamGroupList(teamId);
      getSwimmerListByTeam("teamID", teamId);
    } else {
      setIsTeamGroupDropDownDisabled(true);
    }
  }


  const handleTeamGroupSelectionWithSearchFilter = (groupId) => {
    setTeamGroupSelection(groupId);
    setSwimmerSelection([]);
    setIsGroupDropdownOpen(false);

    if (groupId != "0") {
      setIsSwimmerDropDownDisabled(false);
      getSwimmerListByTeam(groupId);
    } else {
      setIsSwimmerDropDownDisabled(false);
      getSwimmerListByTeam("teamID", teamSelection);
    }
  };

  return (
    <>
      <div className="wrapper">
        {loading && <Loader />}
        <Nav />

        <div id="content">
          <header>
            <div className="dashboard_header">
              <div className="left-side d-flex ">
                <button
                  type="button"
                  id="sidebarCollapse"
                  className="btn btn-link bt_none"
                >
                  {" "}
                  <i className="fa fa-align-left"></i>{" "}
                </button>
                <h1>Admin Dashboard </h1>{" "}
              </div>

              <div className="row">
                <div className="maindiv"></div>

                <DropdownRight />
              </div>
            </div>
          </header>

          <div class="row align-items-center  Analysts_tabs Edit_Setting custom_dropdown_height">
            
            {/* <div
              className="map_btn mt-3 mx-3"
              style={{
                position: "relative",
              }}
            >
              <select
                onChange={handleTeamDropDown}
                name="Team"
                className="form-control custom_input"
                style={{ width: "250px" }}
                value={teamSelection}
              >
                <option value="0" selected>
                  Search by Team
                </option>
                {teamData?.map((item, i) => (
                  <option key={i} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
              <div class="img_icon new custom_icon_height">
                <img src={dropdown} alt="" />
              </div>
            </div> */}


            <div className="map_btn mt-3 mx-3" style={{ position: "relative" }}>
              <div
                onClick={() => {setIsDropdownOpen(!isDropdownOpen);setIsGroupDropdownOpen(false);setIsSwimmerDropdownOpen(false)}}
                className="form-control custom_input"
                style={{
                  width: "250px",
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  fontFamily: "SF Pro Text",
                  fontWeight: 'normal',
                  fontSize: '20px',
                  color: '#3c3c3c',
                }}
              >
                {teamSelection == '0' || (Array.isArray(teamSelection) && teamSelection.length === 0)
                  ? 'Select a Team'
                  : teamData.find(item => item.id === teamSelection)?.name}
                <div className="img_icon new custom_icon_height" style={{ marginLeft: 'auto' }}>
                  <img src={dropdown} alt="" />
                </div>
              </div>

              {isDropdownOpen && (
                <div
                  className="custom-dropdown"
                  style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    width: '100%',
                    backgroundColor: 'white',
                    border: '1px solid #ccc',
                    zIndex: 1,
                    maxHeight: '500px',
                    overflowY: 'auto',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                  }}
                >
                  <input
                    type="text"
                    placeholder="Search by Team"
                    className="form-control"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ marginBottom: '10px', width: 'calc(100% - 20px)', marginLeft: '10px', marginTop: '10px' }} // Adjust width to fit dropdown
                  />

                  <div
                    className="dropdown-item"
                    style={{
                      padding: '5px 10px',
                      cursor: 'pointer',
                      fontFamily: "SF Pro Text",
                      fontWeight: 'normal',
                      fontSize: '20px',
                      color: teamSelection == '0' || (Array.isArray(teamSelection) && teamSelection.length === 0)  ? 'white' : '#3c3c3c',
                      backgroundColor: teamSelection == '0' || (Array.isArray(teamSelection) && teamSelection.length === 0) ? '#0f4e9b' : 'transparent', // Background for "Select a Team"
                    }}
                    onClick={() => handleTeamSelectionWithSearchFilter(0)}
                  >
                    Select a Team
                  </div>

                  {filteredTeamData.length > 0 ? (
                    filteredTeamData.map((item, i) => (
                      <div
                        key={i}
                        className="dropdown-item"
                        style={{
                          padding: '5px 10px',
                          cursor: 'pointer',
                          fontFamily: "SF Pro Text",
                          fontWeight: 'normal',
                          fontSize: '20px',
                          color: teamSelection === item.id ? 'white' : '#3c3c3c',
                          backgroundColor: teamSelection === item.id ? '#0f4e9b' : 'transparent', // Background for selected team
                        }}
                        onClick={() => { handleTeamSelectionWithSearchFilter(item.id); setSearchTerm('') }} // Option click handler for teams
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#d3d3d3'} // Hover effect
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = teamSelection === item.id ? '#0f4e9b' : 'transparent'} // Reset background color
                      >
                        {item.name}
                      </div>
                    ))
                  ) : (
                    <div className="dropdown-item" style={{
                      padding: '5px 10px',
                      fontFamily: "SF Pro Text",
                      fontWeight: 'normal',
                      fontSize: '20px',
                      color: '#3c3c3c',
                    }}>
                      No teams found
                    </div>
                  )}
                </div>
              )}
            </div>



            {/* <div
              className="map_btn mt-3 mx-3"
              style={{
                position: "relative",
              }}
            >
              <select
                onChange={handleTeamGroupDropDown}
                name="TeamGroup"
                className="form-control custom_input"
                style={{ width: "250px" }}
                disabled={isTeamGroupDropDownDisabled}
                key={teamSelection}
              >
                <option value="0" selected>
                  Search by Group
                </option>
                {teamGroupData?.map((item, i) => (
                  <option key={i} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
              <div class="img_icon new custom_icon_height">
                <img src={dropdown} alt="" />
              </div>
            </div> */}

          <div className="map_btn mt-3 mx-3" style={{ position: "relative" }}>
            <div
              onClick={() => {!isTeamGroupDropDownDisabled && setIsGroupDropdownOpen(!isGroupDropdownOpen);setIsDropdownOpen(false);setIsSwimmerDropdownOpen(false)}}
              className="form-control custom_input"
              style={{
                width: "250px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                fontFamily: "SF Pro Text",
                fontWeight: "normal",
                fontSize: "20px",
                color: "#3c3c3c",
                opacity: !isTeamGroupDropDownDisabled ? 1 : 0.6    
              }}
            >
              {teamGroupSelection == "0" || (Array.isArray(teamGroupSelection) && teamGroupSelection.length === 0)
                ? "Select a Group"
                : teamGroupData.find(item => item.id === teamGroupSelection)?.name}
              <div className="img_icon new custom_icon_height" style={{ marginLeft: "auto" }}>
                <img src={dropdown} alt="" />
              </div>
            </div>

            {isGroupDropdownOpen && (
              <div
                className="custom-dropdown"
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  width: "100%",
                  backgroundColor: "white",
                  border: "1px solid #ccc",
                  zIndex: 1,
                  maxHeight: "500px",
                  overflowY: "auto",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                }}
              >
                <input
                  type="text"
                  placeholder="Search by Group"
                  className="form-control"
                  value={groupSearchTerm}
                  onChange={(e) => setGroupSearchTerm(e.target.value)}
                  style={{ marginBottom: "10px", width: "calc(100% - 20px)", marginLeft: "10px", marginTop: "10px" }} // Adjust width to fit dropdown
                />

                <div
                  className="dropdown-item"
                  style={{
                    padding: "5px 10px",
                    cursor: "pointer",
                    fontFamily: "SF Pro Text",
                    fontWeight: "normal",
                    fontSize: "20px",
                    color: teamGroupSelection == "0" || (Array.isArray(teamGroupSelection) && teamGroupSelection.length === 0) ? "white" : "#3c3c3c",
                    backgroundColor: teamGroupSelection == "0" || (Array.isArray(teamGroupSelection) && teamGroupSelection.length === 0) ? "#0f4e9b" : "transparent", // Background for "Select a Group"
                  }}
                  onClick={() => handleTeamGroupSelectionWithSearchFilter(0)} // Clear selection
                >
                  Select a Group
                </div>

                {filteredGroupData.length > 0 ? (
                  filteredGroupData.map((item, i) => (
                    <div
                      key={i}
                      className="dropdown-item"
                      style={{
                        padding: "5px 10px",
                        cursor: "pointer",
                        fontFamily: "SF Pro Text",
                        fontWeight: "normal",
                        fontSize: "20px",
                        color: teamGroupSelection === item.id ? "white" : "#3c3c3c",
                        backgroundColor: teamGroupSelection === item.id ? "#0f4e9b" : "transparent", // Background for selected group
                      }}
                      onClick={() => { handleTeamGroupSelectionWithSearchFilter(item.id ); setGroupSearchTerm(''); }} // Option click handler for groups
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#d3d3d3"} // Hover effect
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = teamGroupSelection === item.id ? "#0f4e9b" : "transparent"} // Reset background color
                    >
                      {item.name}
                    </div>
                  ))
                ) : (
                  <div className="dropdown-item" style={{
                    padding: "5px 10px",
                    fontFamily: "SF Pro Text",
                    fontWeight: "normal",
                    fontSize: "20px",
                    color: "#3c3c3c",
                  }}>
                    No groups found
                  </div>
                )}
              </div>
            )}
          </div>

            

            

            {/* <div
              className="map_btn mt-3 mx-3"
              style={{
                position: "relative",
              }}
            >
              <select
                onChange={handleSwimmerDropDown}
                name="Swimmer"
                className="form-control custom_input"
                style={{ width: "250px" }}
                disabled={isSwimmerDropDownDisabled}
                key={`${teamGroupSelection}-${teamSelection}`}
              >
                <option value="0" selected>
                  Search by Swimmer
                </option>
                {swimmerDataByTeam &&
                  swimmerDataByTeam?.map((item, i) => (
                    <option key={i} value={item.id}>
                      {item.fullname}
                    </option>
                  ))}
              </select>
              <div class="img_icon new custom_icon_height">
                <img src={dropdown} alt="" />
              </div>
            </div> */}

            <div className="map_btn mt-3 mx-3" style={{ position: "relative" }}>
              <div
                onClick={() => {!isSwimmerDropDownDisabled && setIsSwimmerDropdownOpen(!isSwimmerDropdownOpen);setIsDropdownOpen(false);setIsGroupDropdownOpen(false)}}
                className="form-control custom_input"
                style={{
                  width: "250px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  fontFamily: "SF Pro Text",
                  fontWeight: "normal",
                  fontSize: "20px",
                  color: "#3c3c3c",
                  opacity:!isSwimmerDropDownDisabled ?  1 : 0.6
                }}
              >
                {swimmerSelection == "0" || (Array.isArray(swimmerSelection) && swimmerSelection.length === 0)
                  ? "Select a Swimmer"
                  : swimmerDataByTeam.find(item => item.id === swimmerSelection)?.fullname}
                <div className="img_icon new custom_icon_height" style={{ marginLeft: "auto" }}>
                  <img src={dropdown} alt="" />
                </div>
              </div>

              {isSwimmerDropdownOpen && (
                <div
                  className="custom-dropdown"
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    width: "100%",
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    zIndex: 1,
                    maxHeight: "500px",
                    overflowY: "auto",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                  }}
                >
                  <input
                    type="text"
                    placeholder="Search by Swimmer"
                    className="form-control"
                    value={swimmerSearchTerm}
                    onChange={(e) => setSwimmerSearchTerm(e.target.value)}
                    style={{ marginBottom: "10px", width: "calc(100% - 20px)", marginLeft: "10px", marginTop: "10px" }} // Adjust width to fit dropdown
                  />

                  <div
                    className="dropdown-item"
                    style={{
                      padding: "5px 10px",
                      cursor: "pointer",
                      fontFamily: "SF Pro Text",
                      fontWeight: "normal",
                      fontSize: "20px",
                      color: swimmerSelection == "0" || (Array.isArray(swimmerSelection) && swimmerSelection.length === 0) ? "white" : "#3c3c3c",
                      backgroundColor: swimmerSelection == "0" || (Array.isArray(swimmerSelection) && swimmerSelection.length === 0) ? "#0f4e9b" : "transparent", // Background for "Select a Swimmer"
                    }}
                    onClick={() => handleSwimmerDropDown({ target: { value: "0" } })} // Clear selection
                  >
                    Select a Swimmer
                  </div>

                  {filteredSwimmerData.length > 0 ? (
                    filteredSwimmerData.map((item, i) => (
                      <div
                        key={i}
                        className="dropdown-item"
                        style={{
                          padding: "5px 10px",
                          cursor: "pointer",
                          fontFamily: "SF Pro Text",
                          fontWeight: "normal",
                          fontSize: "20px",
                          color: swimmerSelection === item.id ? "white" : "#3c3c3c",
                          backgroundColor: swimmerSelection === item.id ? "#0f4e9b" : "transparent", // Background for selected swimmer
                        }}
                        onClick={() => { handleSwimmerDropDown({ target: { value: item.id } }); setSwimmerSearchTerm(''); }} // Option click handler for swimmers
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#d3d3d3"} // Hover effect
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = swimmerSelection === item.id ? "#0f4e9b" : "transparent"} // Reset background color
                      >
                        {item.fullname}
                      </div>
                    ))
                  ) : (
                    <div className="dropdown-item" style={{
                      padding: "5px 10px",
                      fontFamily: "SF Pro Text",
                      fontWeight: "normal",
                      fontSize: "20px",
                      color: "#3c3c3c",
                    }}>
                      No swimmers found
                    </div>
                  )}
                </div>
              )}
            </div>


            <div className="mt-3 mx-3">
              {/* <DatePicker
                selected={monthAndYear}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                showFullMonthYearPicker
                onChange={handleMonthAndYear}
                className="custom_dashboard_datepicker"
                placeholderText="Select month"
              /> */}
              <DatePicker
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => {
                  handleDatePicker(update)
                }}
                isClearable={true}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                className="custom_dashboard_datepicker"
                placeholderText="Select date range"
              />
            </div>

            <div className="mt-3 mx-3 mb-4">
              <button
                onClick={handleClearAll}
                className="btn btn-secondary"
                style={{ display: "flex", alignItems: "center" }}
              >
                Clear
              </button>
            </div>
          </div>

          <div className="dashbord_content">
            <div className="row status_card">
              <div className="col-xl-4 col-lg-6 col-md-6">
                <div className="card h_300">
                  <div className="status_wrpaer d-flex justify-content-between align-items-center">
                    <h1>
                      <img src={statusImg} className="mr-2" /> Videos Filmed
                    </h1>
                  </div>
                  <div className="row">
                    <div className="col-7">
                      <h2 className="price-total">{totalVideoFilmed}</h2>
                      <div className="status_list mt-3">
                        <ul>
                          {videoFilmed?.map((item) => (
                            <li>
                              <div className="row align-items-center">
                                <div
                                  style={{
                                    backgroundColor: item.fill,
                                    width: 20,
                                    height: 5,
                                    borderRadius: 5,
                                  }}
                                ></div>
                                <div className="col">
                                  By {item.name} ({item.value})
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div className="col-5">
                      <ResponsiveContainer width="100%" height={180}>
                        <PieChart>
                          <Pie
                            dataKey="value"
                            data={videoFilmed}
                            cx="50%"
                            cy="50%"
                            innerRadius="40%"
                            outerRadius="80%"
                            fill="#82ca9d"
                            labelLine={false}
                            label={({
                              cx,
                              cy,
                              midAngle,
                              innerRadius,
                              outerRadius,
                              value,
                            }) => {
                              const radius =
                                innerRadius + (outerRadius - innerRadius) / 2;
                              const x =
                                cx +
                                radius * Math.cos((-midAngle * Math.PI) / 180);
                              const y =
                                cy +
                                radius * Math.sin((-midAngle * Math.PI) / 180);

                              return (
                                <text
                                  x={x}
                                  y={y}
                                  fill="#fff"
                                  textAnchor="middle"
                                  dominantBaseline="central"
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {value}
                                </text>
                              );
                            }}
                          />
                          <Tooltip />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6">
                <div className="card h_300">
                  <div className="status_wrapper d-flex justify-content-between align-items-center">
                    <h1>
                      <img src={statusImg} className="mr-2" alt="Status" />{" "}
                      Videos Viewed
                    </h1>
                  </div>
                  <div className="row">
                    <div className="col-7">
                      <h2 className="price-total">
                        {videoViewedDetails &&
                          videoViewedDetails.totalVideosViewed}
                      </h2>
                      <div className="status_list mt-3">
                        <ul>
                          {videoViewedDetails &&
                            videoViewedDetails
                              ?.videoViewedCountWithBackgroundColor?.length >
                            0 &&
                            videoViewedDetails.videoViewedCountWithBackgroundColor.map(
                              (item, index) => (
                                <li key={index}>
                                  <div className="row align-items-center">
                                    <div
                                      style={{
                                        backgroundColor: item.fill,
                                        width: 20,
                                        height: 5,
                                        borderRadius: 5,
                                      }}
                                    ></div>
                                    <div className="col">
                                      By {item.name} ({item.value})
                                    </div>
                                  </div>
                                </li>
                              )
                            )}
                        </ul>
                      </div>
                    </div>
                    <div className="col-5">
                      <ResponsiveContainer width="100%" height={180}>
                        <PieChart>
                          <Pie
                            dataKey="value"
                            data={
                              videoViewedDetails &&
                              videoViewedDetails.videoViewedCountWithBackgroundColor
                            }
                            cx="50%"
                            cy="50%"
                            innerRadius="40%"
                            outerRadius="80%"
                            fill="#82ca9d"
                            labelLine={false}
                            label={({
                              cx,
                              cy,
                              midAngle,
                              innerRadius,
                              outerRadius,
                              value,
                            }) => {
                              const radius =
                                innerRadius + (outerRadius - innerRadius) / 2;
                              const x =
                                cx +
                                radius * Math.cos((-midAngle * Math.PI) / 180);
                              const y =
                                cy +
                                radius * Math.sin((-midAngle * Math.PI) / 180);

                              return (
                                <text
                                  x={x}
                                  y={y}
                                  fill="#fff"
                                  textAnchor="middle"
                                  dominantBaseline="central"
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {value}
                                </text>
                              );
                            }}
                          />
                          <Tooltip />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6">
                <div className="card h_300">
                  <div className="status_wrpaer d-flex justify-content-between align-items-center">
                    <h1>
                      <img src={statusImg} className="mr-2" /> Evo Orders
                    </h1>
                  </div>
                  <div className="row">
                    <div className="col-7">
                      <h2 className="price-total">
                        {order && order.orderTotal}
                      </h2>
                      <div className="status_list mt-3">
                        <ul>
                          {evo?.map((item, index) => (
                            <li key={index}>
                              <div className="row align-items-center">
                                <div
                                  style={{
                                    backgroundColor: item.fill,
                                    width: 20,
                                    height: 5,
                                    borderRadius: 5,
                                  }}
                                ></div>
                                <div className="col">
                                  {item.name} ({item.value})
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div className="col-5">
                      <ResponsiveContainer width="100%" height={180}>
                        <PieChart>
                          <Pie
                            dataKey="value"
                            data={evo}
                            cx="50%"
                            cy="50%"
                            innerRadius="40%"
                            outerRadius="80%"
                            fill="#82ca9d"
                            labelLine={false}
                            label={({
                              cx,
                              cy,
                              midAngle,
                              innerRadius,
                              outerRadius,
                              value,
                            }) => {
                              const radius =
                                innerRadius + (outerRadius - innerRadius) / 2;
                              const x =
                                cx +
                                radius * Math.cos((-midAngle * Math.PI) / 180);
                              const y =
                                cy +
                                radius * Math.sin((-midAngle * Math.PI) / 180);

                              return (
                                <text
                                  x={x}
                                  y={y}
                                  fill="#fff"
                                  textAnchor="middle"
                                  dominantBaseline="central"
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {value}
                                </text>
                              );
                            }}
                          />
                          <Tooltip />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6">
                <div className="card h_300">
                  <div className="status_wrpaer d-flex justify-content-between align-items-center">
                    <h1>
                      <img src={statusImg} className="mr-2" />
                      Total Swimmers
                    </h1>{" "}
                  </div>
                  <div className="row">
                    <div className="col-7">
                      <h2 className="price-total">
                        {gender && gender.genderTotal}
                      </h2>
                      <div className="status_list mt-3">
                        <ul>
                          {swimmer &&
                            swimmer.map((item, index) => (
                              <li key={index}>
                                <div className="row align-items-center">
                                  <div
                                    style={{
                                      backgroundColor: item.fill,
                                      width: 20,
                                      height: 5,
                                      borderRadius: 5,
                                    }}
                                  ></div>
                                  <div className="col">
                                    {item.name.charAt(0).toUpperCase() +
                                      item.name.slice(1).toLowerCase()}
                                    ({item.value})
                                  </div>
                                </div>
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                    <div className="col-5">
                      <ResponsiveContainer width="100%" height={180}>
                        <PieChart>
                          <Pie
                            dataKey="value"
                            data={swimmer}
                            cx="50%"
                            cy="50%"
                            innerRadius="40%"
                            outerRadius="80%"
                            fill="#82ca9d"
                            labelLine={false}
                            label={({
                              cx,
                              cy,
                              midAngle,
                              innerRadius,
                              outerRadius,
                              value,
                            }) => {
                              const radius =
                                innerRadius + (outerRadius - innerRadius) / 2;
                              const x =
                                cx +
                                radius * Math.cos((-midAngle * Math.PI) / 180);
                              const y =
                                cy +
                                radius * Math.sin((-midAngle * Math.PI) / 180);

                              return (
                                <text
                                  x={x}
                                  y={y}
                                  fill="#fff"
                                  textAnchor="middle" // Center the text horizontally
                                  dominantBaseline="central" // Center the text vertically
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {value}
                                </text>
                              );
                            }}

                          // startAngle={0}
                          />
                          <Tooltip />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="card">
                  <div className="status_wrpaer d-flex justify-content-between align-items-center">
                    <h1>
                      <img src={statusImg} className="mr-2" /> {dateRange[0] != null && dateRange[1] != null ? `Total Views ${moment(dateRange[0]).format('MMM YYYY')} to ${moment(dateRange[1]).format('MMM YYYY')}` : "Total Views"}
                      {/* Total views in{" "}{moment(monthAndYear).format("MMMM")} */}
                    </h1>
                  </div>
                  <h2 className="price-total">{total}</h2>
                  <div className="graph mt-4">
                    <Bar
                      data={{
                        labels: labels,
                        datasets: [
                          {
                            label: "Male",
                            backgroundColor: "#74c1fc",
                            borderColor: "rgb(255, 132, 238)",

                            hoverBackgroundColor: "#74c1fc",
                            hoverBorderColor: "rgb(255, 132, 238)",
                            data: dataset1,
                          },

                          {
                            label: "Female",
                            backgroundColor: "rgb(255, 132, 238)",
                            borderColor: "rgb(255, 132, 238)",

                            hoverBackgroundColor: "#74c1fc",
                            hoverBorderColor: "rgb(255, 132, 238)",

                            data: dataset2,
                          },
                        ],
                      }}
                      width={100}
                      height={30}
                      options={options}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
